module.exports = __webpack_public_path__ + "static/media/kitchen1.27942afc.png";